import { createFileRoute } from "@tanstack/react-router";

import { DeletionRequestPage } from "../../features/deletion/DeletionRequestPage";

// Outside the signed-in and signed-out layouts: anyone with the tracking code, from the email or Meta, reads it.
export const Route = createFileRoute("/data-deletion/$code")({
  component: function DeletionRequest() {
    return <DeletionRequestPage code={Route.useParams().code} />;
  },
});
